import React from 'react';
import {
  Show,
  TabbedShowLayout,
  Tab,
  DateField,
  NumberField,
  ReferenceField,
  TextField,
  SelectField,
  BooleanField,
  FunctionField,
  CardActions,
  ListButton,
  Labeled,
} from 'react-admin';
import _ from 'lodash';
import {
  getAdminLevel,
  ADMIN_LEVELS,
} from '../../authProvider';

import FullNameField from '../General/FullNameField';

import { offeringCategory, annualIncomeChoices, netWorthChoices } from '../../helpers/mappings';
import OrderActionsDropdown from './OrderActionsDropdown';

const Actions = ({
  basePath,
  data,
  props,
}) => {
  const adminLevel = getAdminLevel();

  return (
    <CardActions>
      <div style={{
          display: 'flex',
          flexDirection: 'column',
          flexGrow: 1,
          alignItems: 'flex-start',
        }}
      >
        <ListButton basePath={basePath} />
      </div>
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        { adminLevel && adminLevel !== ADMIN_LEVELS.READ_ONLY_ADMIN &&
        <OrderActionsDropdown data={data} actionProps={props} basePath={basePath} /> }
      </div>
    </CardActions>
  );
};

const Title = ({ record }) => (
  <span>Offer Order #{record.id}</span>
);

const EndStatusBanner = ({ record }) => (record.endStatus ?
  <div>
    <span className={`${record.endStatus}Banner`}>{record.endStatus}</span>
    {record.isEndStatusChangeEmailSent && <span className="emailStatusBanner">EMAIL SENT</span>}
  </div> :
  <span>-</span>);

export default props => (
  <Show
    {...props}
    title={<Title />}
    actions={<Actions path={props.location.pathname} />}
  >
    <TabbedShowLayout>
      <Tab label="Details">
        <TextField label="Offer Name" source="offer.name" />
        <FunctionField
          label="Offer Category"
          render={record => `${record.isConditional ? offeringCategory.CONDITIONAL.label : offeringCategory.NORMAL.label}`}
        />
        <Labeled label="Order Status">
          <EndStatusBanner />
        </Labeled>
        <TextField source="deliverSecuritiesMode" label="Deliver Securities Mode" />
        <NumberField source="requestedTotalCurrencyAmt" label="Requested Total Currency Amount" options={{ style: 'currency', currency: 'USD' }} />
        <FunctionField
          label="External Offer Order Agreement"
          source="documentLocation"
          render={record => <a href={record.documentLocation} target="_blank" rel="noopener noreferrer">External Offer Order Agreement Document</a>}
        />
        <FunctionField
          addLabel={false}
          render={record => (!_.isEmpty(record.solicitedBy) ?
            <Labeled label="Offer Order Solicited By">
              <ReferenceField label="Offer Order Solicited By" record={record} source="solicitedBy" reference="users" basePath="/users">
                <FullNameField />
              </ReferenceField>
            </Labeled> : <Labeled label="Offer Order Solicited By"><span>-</span></Labeled>)}
        />
        <ReferenceField label="Offer Order Created By" source="createdByUserId" reference="users" linkType="show">
          <FullNameField />
        </ReferenceField>
        <DateField source="createdAt" label="Offer Order Created At" />
        <DateField source="updatedAt" label="Offer Order Updated At" />
      </Tab>
      <Tab label="User Info">
        <ReferenceField label="User" source="userId" reference="users" linkType="show">
          <FullNameField />
        </ReferenceField>
        <TextField source="accountNumber" label="Account" />
        <ReferenceField label="Employment Status" source="userId" reference="users" linkType={false}>
          <TextField source="employment.employmentStatus" label="Employment Status" />
        </ReferenceField>
        <ReferenceField label="Employer Name" source="userId" reference="users" linkType={false}>
          <TextField source="employment.employerName" label="Employer Name" />
        </ReferenceField>
        <ReferenceField label="Annual Income" source="userId" reference="users" linkType={false}>
          <SelectField source="finances.annualIncome" label="Annual Income" choices={annualIncomeChoices} />
        </ReferenceField>
        <ReferenceField label="Liquid Net Worth" source="userId" reference="users" linkType={false}>
          <SelectField source="finances.liquidNetWorth" label="Liquid Net Worth" choices={netWorthChoices} />
        </ReferenceField>
        <ReferenceField label="Total Net Worth" source="userId" reference="users" linkType={false}>
          <SelectField source="finances.totalNetWorth" label="Total Net Worth" choices={netWorthChoices} />
        </ReferenceField>
        <ReferenceField label="FINRA Affiliated" source="userId" reference="users" linkType={false}>
          <BooleanField source="disclosures.finraAffiliated" label="FINRA Affiliated" />
        </ReferenceField>
        <ReferenceField label="Director or 10% Shareholder" source="userId" reference="users" linkType={false}>
          <BooleanField source="disclosures.directorOrTenPercentShareholder" label="Director or 10% Shareholder" />
        </ReferenceField>
      </Tab>
    </TabbedShowLayout>
  </Show>
);



// WEBPACK FOOTER //
// ./src/components/ExternalOfferOrder/Show.js